import { deserialize } from 'cerialize'
import { ShortDataModel } from 'Models'

export class DictsListModel {
	@deserialize public contracts: {
		kinds: ShortDataModel[]
		statuses: ShortDataModel[]
		subject_types: ShortDataModel[]
		action_types: ShortDataModel[]
	}
	@deserialize public platforms: {
		kinds: ShortDataModel[]
	}
	@deserialize public invoices: {
		client_roles: ShortDataModel[]
		contractor_roles: ShortDataModel[]
		statuses: ShortDataModel[]
	}
	@deserialize public creatives: {
		kinds: ShortDataModel[]
		statuses: ShortDataModel[]
		media_states: ShortDataModel[]
		forms: ShortDataModel[]
	}
	@deserialize public organizations: {
		kinds: ShortDataModel[]
		statuses: ShortDataModel[]
	}
	@deserialize public client_roles_for_autogeneration: ShortDataModel[]
	@deserialize public contractor_roles_for_autogeneration: ShortDataModel[]
	@deserialize public kktu_values: ShortDataModel[]
}
